import { render, staticRenderFns } from "./mintNfts.vue?vue&type=template&id=159d3533&scoped=true"
import script from "./mintNfts.vue?vue&type=script&lang=js"
export * from "./mintNfts.vue?vue&type=script&lang=js"
import style0 from "./mintNfts.vue?vue&type=style&index=0&id=159d3533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159d3533",
  null
  
)

export default component.exports